import { render, staticRenderFns } from "./SpaceModify.vue?vue&type=template&id=0ec516d1&scoped=true&"
import script from "./SpaceModify.vue?vue&type=script&lang=js&"
export * from "./SpaceModify.vue?vue&type=script&lang=js&"
import style0 from "./SpaceModify.vue?vue&type=style&index=0&id=0ec516d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec516d1",
  null
  
)

export default component.exports